import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import TemplatesOverviewDialog from "./TemplatesOverviewDialog";
import TemplatesEditDialog from "./TemplatesEditDialog";
import API from "../../../utils/axios";
import { setTemplates } from "../../../store/actions/account";

function TemplatesDialog({
  saveDisabled,
  setSaveDisabled,
  setTemplates,
  handleClose,
  open,
  templatesLoaded,
  templates,
  setTags,
  ...props
}) {
  useEffect(() => {
    if (open) {
      API.get("/v1/templates")
        .then(res => {
          setTemplates(res.data);
        })
        .catch(console.log);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const [currentAction, setCurrentAction] = useState("overview");
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [backFromEditAction, setBackFromEditAction] = useState(false);

  return (
    <>
      {currentAction === "edit" ? (
        <TemplatesEditDialog
          {...props}
          open={open}
          setCurrentAction={setCurrentAction}
          currentTemplate={currentTemplate}
          saveDisabled={saveDisabled}
          setTemplates={setTemplates}
          templates={templates}
          setSaveDisabled={setSaveDisabled}
          setBackFromEditAction={setBackFromEditAction}
        />
      ) : (
        <TemplatesOverviewDialog
          {...props}
          open={open}
          templates={templates}
          setTemplates={setTemplates}
          handleClose={handleClose}
          setCurrentAction={setCurrentAction}
          setCurrentTemplate={setCurrentTemplate}
          setBackFromEditAction={setBackFromEditAction}
          backFromEditAction={backFromEditAction}
          templatesLoaded={templatesLoaded}
        />
      )}
    </>
  );
}

const mapStateToProps = state => ({
  templates: state.account.templates,
  templatesLoaded: state.loading.templatesListLoaded
});

export default connect(mapStateToProps, { setTemplates })(TemplatesDialog);
